import {HgAspectRatio} from '~/design-system/hg/components'
import {type HgHeroCinematicImageVariantProps} from './types'
import {cinematicImageVariants} from './variants'

function CinematicImage({
  layer,
  image,
  variant,
  desktopAspectRatio,
}: {
  image: React.ReactElement
  layer?: HgHeroCinematicImageVariantProps['layer']
} & Pick<HgHeroCinematicImageVariantProps, 'variant' | 'desktopAspectRatio'>) {
  const {container, imageSlot, imageWrapper} = cinematicImageVariants({
    layer,
    variant,
    desktopAspectRatio,
  })

  return (
    <div className={container()}>
      <HgAspectRatio
        classNames={{wrapper: imageWrapper(), assetWrapper: imageSlot()}}
      >
        {image}
      </HgAspectRatio>
    </div>
  )
}

export default function CinematicVariant(props: HgHeroCinematicImageVariantProps) {
  // TODO: Remove when all old cinematic heros are updated
  const variant = props.variant ?? 'old'
  const {outerContainer} = cinematicImageVariants({
    variant,
  })

  return (
    <div className={outerContainer()}>
      {props.maskImage && (
        <CinematicImage
          {...props}
          layer="mask"
          image={props.maskImage}
          variant={variant}
        />
      )}
      <CinematicImage
        {...props}
        layer="background"
        image={props.backgroundAsset}
        variant={variant}
      />
      {/*
       *  Since we cannot simply target the `mask-image` CSS property because it is not animatable,
       *  we can duplicate the background image and fade it out on hover to reveal the mask effect layer.
       */}
      <CinematicImage
        {...props}
        layer="fade"
        image={props.backgroundAsset}
        variant={variant}
      />
    </div>
  )
}
